module.exports = __webpack_public_path__ + "static/img/putcontent_5.d74fb9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/putcontent_5.png
// module id = 6bg+
// module chunks = 1